import PropTypes from "prop-types";

const ValidationType = PropTypes.oneOf(["none", "adult", "DNI", "phone-number", "email"]);

export const FieldShape = PropTypes.oneOfType([
  PropTypes.shape({
    label: PropTypes.string.isRequired,
    subLabel: PropTypes.string,
    value: PropTypes.string.isRequired,
  }),
  PropTypes.shape({
    label: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }),
  PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    type: PropTypes.string,
    csvData: PropTypes.arrayOf(PropTypes.object),
    validation: PropTypes.oneOfType([
      PropTypes.func,
      ValidationType,
      PropTypes.shape({
        type: ValidationType.isRequired,
        errorMessage: PropTypes.string,
      }),
    ]),
  }),
]);

export const ContentWithVarsShape = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.shape({
    content: PropTypes.string,
    variables: PropTypes.arrayOf(PropTypes.string),
  }),
]);

export const StepShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["message", "choice", "submit", "imageChoice"]),
  title: ContentWithVarsShape,
  description: ContentWithVarsShape,
  htmlContent: PropTypes.string,
  fields: PropTypes.arrayOf(FieldShape),
  nextJourney: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
});

export const ThemeShape = PropTypes.shape({
  colorPrimary: PropTypes.string,
  colorSecondary: PropTypes.string,
  colorTertiary: PropTypes.string,
  colorInvertedPrimary: PropTypes.string,
  colorInvertedSecondary: PropTypes.string,
  colorInvertedTertiary: PropTypes.string,
  colorInvertedBackground: PropTypes.string,
  colorTextBase: PropTypes.string,
  colorButtonDisabled: PropTypes.string,
  colorButtonHover: PropTypes.string,
  colorBackground: PropTypes.string,
  colorHeaderTextBase: PropTypes.string,
  colorHeaderBackground: PropTypes.string,
  sizeFontBase: PropTypes.string,
  spacingXs: PropTypes.string,
  spacingS: PropTypes.string,
  spacingM: PropTypes.string,
  spacingL: PropTypes.string,
  spacingXl: PropTypes.string,
  borderRadius: PropTypes.string,
  buttonStickyBreakpoint: PropTypes.string,
  transparencyImgCheckBox: PropTypes.string,
});
